import React2, { createContext, useState, useMemo, useCallback, useEffect, useContext } from 'react';
import { useMediaQuery, ThemeProvider as ThemeProvider$1, CssBaseline, useTheme, Drawer, Box, IconButton, Divider, List, AppBar, Toolbar, Typography, Tooltip, Badge, Avatar, Menu as Menu$1, MenuItem, ListItemIcon, ListItemText, Dialog, DialogTitle, DialogContent, TextField, InputAdornment, Button, FormControl, InputLabel, Select, FormHelperText, FormControlLabel, Checkbox, Paper, LinearProgress, TableContainer, Table, TableHead, TableRow, TableCell, TableSortLabel, TableBody, TablePagination, Card, CardContent, Skeleton, ListItem, DialogContentText, DialogActions, Chip, Fade, CircularProgress, ListItemAvatar, CardHeader, Breadcrumbs as Breadcrumbs$1, Link, Tabs as Tabs$1, Tab, ListItemButton, Collapse, createTheme } from '@mui/material';
export { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Autocomplete, Avatar, AvatarGroup, Backdrop, Badge, BottomNavigation, BottomNavigationAction, Box, Button, ButtonGroup, Card, CardActions, CardContent, CardHeader, CardMedia, Checkbox, Chip, CircularProgress, Collapse, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Fab, Fade, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, Grow, IconButton, InputAdornment, InputLabel, LinearProgress, Link, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader, Menu, MenuItem, MenuList, Modal, OutlinedInput, Pagination, Paper, Popover, Popper, Radio, RadioGroup, Select, Skeleton, Slide, Slider, Snackbar, SpeedDial, SpeedDialAction, SpeedDialIcon, Stack, Step, StepContent, StepLabel, Stepper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Tooltip, Typography, Zoom, useTheme as useMuiTheme } from '@mui/material';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ChevronRight, ChevronLeft, Menu, LightMode, DarkMode, Notifications, Person, Settings, Logout, Close, Search, Clear, Inbox, NavigateNext, ExpandLess, ExpandMore, TrendingUp, TrendingDown, TrendingFlat, Apps } from '@mui/icons-material';
export { AccountBalance as AccountBalanceIcon, Add as AddIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon, Assessment as AssessmentIcon, Business as BusinessIcon, CalendarMonth as CalendarMonthIcon, CheckCircle as CheckCircleIcon, Check as CheckIcon, ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon, Close as CloseIcon, ContentCopy as ContentCopyIcon, Dashboard as DashboardIcon, Delete as DeleteIcon, Download as DownloadIcon, Edit as EditIcon, Error as ErrorIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon, FilterList as FilterListIcon, Help as HelpIcon, Home as HomeIcon, Info as InfoIcon, Logout as LogoutIcon, Menu as MenuIcon, MoreHoriz as MoreHorizIcon, MoreVert as MoreVertIcon, Notifications as NotificationsIcon, People as PeopleIcon, Person as PersonIcon, Print as PrintIcon, Refresh as RefreshIcon, Search as SearchIcon, Settings as SettingsIcon, Share as ShareIcon, Sort as SortIcon, Timeline as TimelineIcon, Upload as UploadIcon, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon, Warning as WarningIcon } from '@mui/icons-material';
import { Controller } from 'react-hook-form';
import { ResponsiveContainer, RadarChart as RadarChart$1, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip as Tooltip$1, Legend, PieChart, Pie, Cell, BarChart as BarChart$1, CartesianGrid, XAxis, YAxis, Bar, LineChart as LineChart$1, Line } from 'recharts';
export { CartesianGrid, Cell, Tooltip as ChartTooltip, Legend, ResponsiveContainer, XAxis, YAxis } from 'recharts';

// src/theme/tokens.ts
var colors = {
  // Primary palette
  primary: {
    main: "#1976d2",
    light: "#42a5f5",
    dark: "#1565c0",
    contrastText: "#ffffff"
  },
  // Secondary palette
  secondary: {
    main: "#9c27b0",
    light: "#ba68c8",
    dark: "#7b1fa2",
    contrastText: "#ffffff"
  },
  // Status colors
  success: {
    main: "#2e7d32",
    light: "#4caf50",
    dark: "#1b5e20",
    contrastText: "#ffffff"
  },
  warning: {
    main: "#ed6c02",
    light: "#ff9800",
    dark: "#e65100",
    contrastText: "#ffffff"
  },
  error: {
    main: "#d32f2f",
    light: "#ef5350",
    dark: "#c62828",
    contrastText: "#ffffff"
  },
  info: {
    main: "#0288d1",
    light: "#03a9f4",
    dark: "#01579b",
    contrastText: "#ffffff"
  },
  // Greys
  grey: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121"
  },
  // Background
  background: {
    default: "#f5f5f5",
    paper: "#ffffff",
    dark: "#121212"
  },
  // Text
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // Chart colors (from core constants)
  chart: {
    blue: "#2196F3",
    green: "#4CAF50",
    orange: "#FF9800",
    red: "#F44336",
    purple: "#9C27B0",
    teal: "#009688",
    pink: "#E91E63",
    indigo: "#3F51B5",
    cyan: "#00BCD4",
    amber: "#FFC107"
  }
};
var spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48
};
var borderRadius = {
  none: 0,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  full: 9999
};
var shadows = {
  none: "none",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
};
var typography = {
  fontFamily: {
    primary: '"Roboto", "Helvetica", "Arial", sans-serif',
    mono: '"Roboto Mono", "Courier New", monospace'
  },
  fontSize: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem"
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75
  }
};
var breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
};
var zIndex = {
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var transitions = {
  duration: {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    complex: 375,
    entering: 225,
    leaving: 195
  },
  easing: {
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
  }
};
var layout = {
  sidebarWidth: 280,
  sidebarCollapsedWidth: 64,
  topBarHeight: 64,
  footerHeight: 48,
  maxContentWidth: 1200
};
var ThemeContext = createContext(null);
var createAppTheme = (mode, direction) => {
  const isDark = mode === "dark";
  const themeOptions = {
    direction,
    palette: {
      mode,
      primary: colors.primary,
      secondary: colors.secondary,
      success: colors.success,
      warning: colors.warning,
      error: colors.error,
      info: colors.info,
      grey: colors.grey,
      background: {
        default: isDark ? "#121212" : colors.background.default,
        paper: isDark ? "#1e1e1e" : colors.background.paper
      },
      text: {
        primary: isDark ? "rgba(255, 255, 255, 0.87)" : colors.text.primary,
        secondary: isDark ? "rgba(255, 255, 255, 0.6)" : colors.text.secondary,
        disabled: isDark ? "rgba(255, 255, 255, 0.38)" : colors.text.disabled
      }
    },
    typography: {
      fontFamily: typography.fontFamily.primary,
      h1: {
        fontSize: typography.fontSize["4xl"],
        fontWeight: typography.fontWeight.bold,
        lineHeight: typography.lineHeight.tight
      },
      h2: {
        fontSize: typography.fontSize["3xl"],
        fontWeight: typography.fontWeight.bold,
        lineHeight: typography.lineHeight.tight
      },
      h3: {
        fontSize: typography.fontSize["2xl"],
        fontWeight: typography.fontWeight.semibold,
        lineHeight: typography.lineHeight.tight
      },
      h4: {
        fontSize: typography.fontSize.xl,
        fontWeight: typography.fontWeight.semibold,
        lineHeight: typography.lineHeight.normal
      },
      h5: {
        fontSize: typography.fontSize.lg,
        fontWeight: typography.fontWeight.medium,
        lineHeight: typography.lineHeight.normal
      },
      h6: {
        fontSize: typography.fontSize.md,
        fontWeight: typography.fontWeight.medium,
        lineHeight: typography.lineHeight.normal
      },
      body1: {
        fontSize: typography.fontSize.md,
        lineHeight: typography.lineHeight.normal
      },
      body2: {
        fontSize: typography.fontSize.sm,
        lineHeight: typography.lineHeight.normal
      },
      caption: {
        fontSize: typography.fontSize.xs,
        lineHeight: typography.lineHeight.normal
      },
      button: {
        textTransform: "none",
        fontWeight: typography.fontWeight.medium
      }
    },
    shape: {
      borderRadius: borderRadius.md
    },
    breakpoints: {
      values: breakpoints
    },
    transitions: {
      duration: transitions.duration,
      easing: transitions.easing
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: borderRadius.md,
            padding: "8px 16px"
          },
          contained: {
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none"
            }
          }
        },
        defaultProps: {
          disableElevation: true
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: borderRadius.lg,
            boxShadow: isDark ? "0 1px 3px 0 rgba(0, 0, 0, 0.3)" : "0 1px 3px 0 rgba(0, 0, 0, 0.1)"
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none"
          }
        }
      },
      MuiTextField: {
        defaultProps: {
          variant: "outlined",
          size: "small"
        }
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            borderBottom: `1px solid ${isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)"}`
          }
        },
        defaultProps: {
          color: "inherit"
        }
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            borderRight: `1px solid ${isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)"}`
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: `1px solid ${isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)"}`
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: borderRadius.sm
          }
        }
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: borderRadius.md
          }
        }
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: borderRadius.lg
          }
        }
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            borderRadius: borderRadius.sm,
            fontSize: typography.fontSize.xs
          }
        }
      }
    }
  };
  return createTheme(themeOptions);
};
function ThemeProvider({
  children,
  defaultMode = "system",
  defaultDirection = "ltr",
  storageKey = "platform-theme"
}) {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [mode, setModeState] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem(`${storageKey}-mode`);
      if (stored === "light" || stored === "dark" || stored === "system") {
        return stored;
      }
    }
    return defaultMode;
  });
  const [direction, setDirectionState] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem(`${storageKey}-direction`);
      if (stored === "ltr" || stored === "rtl") {
        return stored;
      }
    }
    return defaultDirection;
  });
  const actualMode = useMemo(() => {
    if (mode === "system") {
      return prefersDarkMode ? "dark" : "light";
    }
    return mode;
  }, [mode, prefersDarkMode]);
  const setMode = useCallback((newMode) => {
    setModeState(newMode);
    if (typeof window !== "undefined") {
      localStorage.setItem(`${storageKey}-mode`, newMode);
    }
  }, [storageKey]);
  const toggleMode = useCallback(() => {
    setMode(actualMode === "light" ? "dark" : "light");
  }, [actualMode, setMode]);
  const setDirection = useCallback((newDirection) => {
    setDirectionState(newDirection);
    if (typeof window !== "undefined") {
      localStorage.setItem(`${storageKey}-direction`, newDirection);
      document.documentElement.dir = newDirection;
    }
  }, [storageKey]);
  useEffect(() => {
    document.documentElement.dir = direction;
  }, [direction]);
  const theme = useMemo(
    () => createAppTheme(actualMode, direction),
    [actualMode, direction]
  );
  const contextValue = useMemo(
    () => ({
      mode,
      actualMode,
      setMode,
      toggleMode,
      direction,
      setDirection
    }),
    [mode, actualMode, setMode, toggleMode, direction, setDirection]
  );
  return /* @__PURE__ */ jsx(ThemeContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsxs(ThemeProvider$1, { theme, children: [
    /* @__PURE__ */ jsx(CssBaseline, {}),
    children
  ] }) });
}
function useTheme2() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
function Sidebar({
  items,
  activeItemId,
  collapsed = false,
  onCollapsedChange,
  logo,
  logoCollapsed,
  footer,
  onItemClick,
  width = layout.sidebarWidth,
  collapsedWidth = layout.sidebarCollapsedWidth
}) {
  const theme = useTheme();
  const [expandedItems, setExpandedItems] = useState(/* @__PURE__ */ new Set());
  const toggleExpanded = useCallback((id) => {
    setExpandedItems((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);
  const handleItemClick = useCallback(
    (item) => {
      if (item.children && item.children.length > 0) {
        toggleExpanded(item.id);
      } else {
        item.onClick?.();
        onItemClick?.(item);
      }
    },
    [toggleExpanded, onItemClick]
  );
  const isActive = useCallback(
    (item) => {
      if (item.id === activeItemId) return true;
      if (item.children) {
        return item.children.some((child) => isActive(child));
      }
      return false;
    },
    [activeItemId]
  );
  const renderNavItem = (item, depth = 0) => {
    const hasChildren = item.children && item.children.length > 0;
    const expanded = expandedItems.has(item.id);
    const active = isActive(item);
    const listItemContent = /* @__PURE__ */ jsxs(
      ListItemButton,
      {
        onClick: () => handleItemClick(item),
        disabled: item.disabled,
        selected: item.id === activeItemId,
        sx: {
          minHeight: 48,
          pl: collapsed ? 2 : 2 + depth * 2,
          pr: 2,
          borderRadius: 1,
          mx: 1,
          mb: 0.5,
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main + "14",
            "&:hover": {
              backgroundColor: theme.palette.primary.main + "24"
            }
          }
        },
        children: [
          item.icon && /* @__PURE__ */ jsx(
            ListItemIcon,
            {
              sx: {
                minWidth: collapsed ? 0 : 40,
                color: active ? theme.palette.primary.main : "inherit"
              },
              children: item.icon
            }
          ),
          !collapsed && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              ListItemText,
              {
                primary: item.label,
                primaryTypographyProps: {
                  fontWeight: active ? 600 : 400,
                  color: active ? theme.palette.primary.main : "inherit"
                }
              }
            ),
            item.badge && /* @__PURE__ */ jsx(
              Box,
              {
                component: "span",
                sx: {
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                  borderRadius: 1,
                  px: 1,
                  py: 0.25,
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  mr: hasChildren ? 1 : 0
                },
                children: item.badge
              }
            ),
            hasChildren && (expanded ? /* @__PURE__ */ jsx(ExpandLess, {}) : /* @__PURE__ */ jsx(ExpandMore, {}))
          ] })
        ]
      }
    );
    return /* @__PURE__ */ jsxs(React2.Fragment, { children: [
      /* @__PURE__ */ jsx(ListItem, { disablePadding: true, sx: { display: "block" }, children: collapsed && item.icon ? /* @__PURE__ */ jsx(Tooltip, { title: item.label, placement: "right", children: listItemContent }) : listItemContent }),
      hasChildren && !collapsed && /* @__PURE__ */ jsx(Collapse, { in: expanded, timeout: "auto", unmountOnExit: true, children: /* @__PURE__ */ jsx(List, { component: "div", disablePadding: true, children: item.children.map((child) => renderNavItem(child, depth + 1)) }) })
    ] }, item.id);
  };
  return /* @__PURE__ */ jsxs(
    Drawer,
    {
      variant: "permanent",
      sx: {
        width: collapsed ? collapsedWidth : width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: collapsed ? collapsedWidth : width,
          boxSizing: "border-box",
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
          }),
          overflowX: "hidden"
        }
      },
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              justifyContent: collapsed ? "center" : "space-between",
              minHeight: layout.topBarHeight,
              px: collapsed ? 1 : 2
            },
            children: [
              collapsed ? logoCollapsed || logo : logo,
              onCollapsedChange && !collapsed && /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: () => onCollapsedChange(true), children: theme.direction === "rtl" ? /* @__PURE__ */ jsx(ChevronRight, {}) : /* @__PURE__ */ jsx(ChevronLeft, {}) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsx(Box, { sx: { flexGrow: 1, overflow: "auto", py: 1 }, children: /* @__PURE__ */ jsx(List, { component: "nav", disablePadding: true, children: items.map((item) => renderNavItem(item)) }) }),
        onCollapsedChange && collapsed && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(Box, { sx: { p: 1, display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: () => onCollapsedChange(false), children: theme.direction === "rtl" ? /* @__PURE__ */ jsx(ChevronLeft, {}) : /* @__PURE__ */ jsx(ChevronRight, {}) }) })
        ] }),
        footer && !collapsed && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(Box, { sx: { p: 2 }, children: footer })
        ] })
      ]
    }
  );
}
function TopBar({
  title,
  user,
  showMenuButton = false,
  onMenuClick,
  darkMode = false,
  onDarkModeToggle,
  notificationCount = 0,
  onNotificationsClick,
  onProfileClick,
  onSettingsClick,
  onLogout,
  leftContent,
  rightContent
}) {
  const [anchorEl, setAnchorEl] = React2.useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleProfileClick = () => {
    handleMenuClose();
    onProfileClick?.();
  };
  const handleSettingsClick = () => {
    handleMenuClose();
    onSettingsClick?.();
  };
  const handleLogout = () => {
    handleMenuClose();
    onLogout?.();
  };
  return /* @__PURE__ */ jsx(
    AppBar,
    {
      position: "fixed",
      sx: {
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "background.paper",
        color: "text.primary"
      },
      children: /* @__PURE__ */ jsxs(Toolbar, { sx: { minHeight: layout.topBarHeight }, children: [
        showMenuButton && /* @__PURE__ */ jsx(
          IconButton,
          {
            edge: "start",
            color: "inherit",
            "aria-label": "menu",
            onClick: onMenuClick,
            sx: { mr: 2 },
            children: /* @__PURE__ */ jsx(Menu, {})
          }
        ),
        title && /* @__PURE__ */ jsx(Typography, { variant: "h6", component: "div", sx: { fontWeight: 600 }, children: title }),
        leftContent,
        /* @__PURE__ */ jsx(Box, { sx: { flexGrow: 1 } }),
        rightContent,
        onDarkModeToggle && /* @__PURE__ */ jsx(Tooltip, { title: darkMode ? "Light mode" : "Dark mode", children: /* @__PURE__ */ jsx(IconButton, { color: "inherit", onClick: onDarkModeToggle, sx: { ml: 1 }, children: darkMode ? /* @__PURE__ */ jsx(LightMode, {}) : /* @__PURE__ */ jsx(DarkMode, {}) }) }),
        onNotificationsClick && /* @__PURE__ */ jsx(Tooltip, { title: "Notifications", children: /* @__PURE__ */ jsx(IconButton, { color: "inherit", onClick: onNotificationsClick, sx: { ml: 1 }, children: /* @__PURE__ */ jsx(Badge, { badgeContent: notificationCount, color: "error", children: /* @__PURE__ */ jsx(Notifications, {}) }) }) }),
        user && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Tooltip, { title: "Account", children: /* @__PURE__ */ jsx(
            IconButton,
            {
              onClick: handleAvatarClick,
              sx: { ml: 1 },
              "aria-controls": menuOpen ? "account-menu" : void 0,
              "aria-haspopup": "true",
              "aria-expanded": menuOpen ? "true" : void 0,
              children: /* @__PURE__ */ jsx(
                Avatar,
                {
                  src: user.photoURL,
                  alt: user.displayName,
                  sx: { width: 36, height: 36 },
                  children: user.displayName?.charAt(0).toUpperCase()
                }
              )
            }
          ) }),
          /* @__PURE__ */ jsxs(
            Menu$1,
            {
              id: "account-menu",
              anchorEl,
              open: menuOpen,
              onClose: handleMenuClose,
              onClick: handleMenuClose,
              transformOrigin: { horizontal: "right", vertical: "top" },
              anchorOrigin: { horizontal: "right", vertical: "bottom" },
              PaperProps: {
                elevation: 3,
                sx: {
                  mt: 1.5,
                  minWidth: 200,
                  "& .MuiMenuItem-root": {
                    px: 2,
                    py: 1
                  }
                }
              },
              children: [
                /* @__PURE__ */ jsxs(Box, { sx: { px: 2, py: 1.5 }, children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "subtitle2", fontWeight: 600, children: user.displayName }),
                  /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: user.email })
                ] }),
                /* @__PURE__ */ jsx(Divider, {}),
                onProfileClick && /* @__PURE__ */ jsxs(MenuItem, { onClick: handleProfileClick, children: [
                  /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(Person, { fontSize: "small" }) }),
                  /* @__PURE__ */ jsx(ListItemText, { children: "Profile" })
                ] }),
                onSettingsClick && /* @__PURE__ */ jsxs(MenuItem, { onClick: handleSettingsClick, children: [
                  /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(Settings, { fontSize: "small" }) }),
                  /* @__PURE__ */ jsx(ListItemText, { children: "Settings" })
                ] }),
                onLogout && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Divider, {}),
                  /* @__PURE__ */ jsxs(MenuItem, { onClick: handleLogout, children: [
                    /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(Logout, { fontSize: "small" }) }),
                    /* @__PURE__ */ jsx(ListItemText, { children: "Logout" })
                  ] })
                ] })
              ]
            }
          )
        ] })
      ] })
    }
  );
}
function ToolLauncher({
  open,
  onClose,
  tools,
  onToolSelect,
  title = "Quick Launch",
  placeholder = "Search tools...",
  recentToolIds = [],
  showCategories = true
}) {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const filteredTools = useMemo(() => {
    if (!searchQuery.trim()) {
      return tools;
    }
    const query = searchQuery.toLowerCase();
    return tools.filter((tool) => {
      const nameMatch = tool.name.toLowerCase().includes(query);
      const descMatch = tool.description?.toLowerCase().includes(query);
      const keywordMatch = tool.keywords?.some((k) => k.toLowerCase().includes(query));
      const categoryMatch = tool.category?.toLowerCase().includes(query);
      return nameMatch || descMatch || keywordMatch || categoryMatch;
    });
  }, [tools, searchQuery]);
  const recentTools = useMemo(() => {
    if (!recentToolIds.length || searchQuery.trim()) return [];
    return recentToolIds.map((id) => tools.find((t) => t.id === id)).filter((t) => !!t);
  }, [tools, recentToolIds, searchQuery]);
  const groupedTools = useMemo(() => {
    if (!showCategories || searchQuery.trim()) {
      return { "": filteredTools };
    }
    return filteredTools.reduce(
      (acc, tool) => {
        const category = tool.category || "Other";
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(tool);
        return acc;
      },
      {}
    );
  }, [filteredTools, showCategories, searchQuery]);
  const handleToolClick = (tool) => {
    if (tool.disabled) return;
    tool.onClick?.();
    onToolSelect?.(tool);
    onClose();
    setSearchQuery("");
  };
  const handleClose = () => {
    onClose();
    setSearchQuery("");
  };
  const renderToolItem = (tool) => /* @__PURE__ */ jsx(ListItem, { disablePadding: true, children: /* @__PURE__ */ jsxs(
    ListItemButton,
    {
      onClick: () => handleToolClick(tool),
      disabled: tool.disabled,
      sx: {
        borderRadius: 1,
        mx: 1,
        "&:hover": {
          backgroundColor: theme.palette.action.hover
        }
      },
      children: [
        /* @__PURE__ */ jsx(ListItemIcon, { sx: { minWidth: 40 }, children: tool.icon || /* @__PURE__ */ jsx(Apps, {}) }),
        /* @__PURE__ */ jsx(
          ListItemText,
          {
            primary: tool.name,
            secondary: tool.description,
            primaryTypographyProps: { fontWeight: 500 },
            secondaryTypographyProps: {
              noWrap: true,
              sx: { maxWidth: 300 }
            }
          }
        )
      ]
    }
  ) }, tool.id);
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      open,
      onClose: handleClose,
      maxWidth: "sm",
      fullWidth: true,
      PaperProps: {
        sx: {
          borderRadius: 2,
          maxHeight: "80vh"
        }
      },
      children: [
        /* @__PURE__ */ jsx(DialogTitle, { sx: { pb: 1 }, children: /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            },
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h6", fontWeight: 600, children: title }),
              /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: handleClose, children: /* @__PURE__ */ jsx(Close, {}) })
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs(DialogContent, { sx: { pt: 0 }, children: [
          /* @__PURE__ */ jsx(
            TextField,
            {
              fullWidth: true,
              autoFocus: true,
              placeholder,
              value: searchQuery,
              onChange: (e) => setSearchQuery(e.target.value),
              InputProps: {
                startAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(Search, { color: "action" }) })
              },
              sx: { mb: 2 }
            }
          ),
          recentTools.length > 0 && /* @__PURE__ */ jsxs(Box, { sx: { mb: 2 }, children: [
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "overline",
                color: "text.secondary",
                sx: { px: 2, display: "block" },
                children: "Recent"
              }
            ),
            /* @__PURE__ */ jsx(List, { dense: true, disablePadding: true, children: recentTools.map(renderToolItem) })
          ] }),
          Object.entries(groupedTools).map(([category, categoryTools]) => /* @__PURE__ */ jsxs(Box, { sx: { mb: 2 }, children: [
            category && showCategories && !searchQuery.trim() && /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "overline",
                color: "text.secondary",
                sx: { px: 2, display: "block" },
                children: category
              }
            ),
            /* @__PURE__ */ jsx(List, { dense: true, disablePadding: true, children: categoryTools.map(renderToolItem) })
          ] }, category)),
          filteredTools.length === 0 && /* @__PURE__ */ jsx(
            Box,
            {
              sx: {
                py: 4,
                textAlign: "center",
                color: "text.secondary"
              },
              children: /* @__PURE__ */ jsxs(Typography, { variant: "body2", children: [
                'No tools found for "',
                searchQuery,
                '"'
              ] })
            }
          )
        ] })
      ]
    }
  );
}
function useToolLauncherShortcut(onOpen, key = "k", modifier = "both") {
  React2.useEffect(() => {
    const handleKeyDown = (event) => {
      const isModifierPressed = modifier === "ctrl" ? event.ctrlKey : modifier === "meta" ? event.metaKey : event.ctrlKey || event.metaKey;
      if (isModifierPressed && event.key.toLowerCase() === key) {
        event.preventDefault();
        onOpen();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onOpen, key, modifier]);
}
function AppShell({
  children,
  // Navigation
  navItems,
  activeNavItemId,
  onNavItemClick,
  // TopBar
  title,
  user,
  darkMode = false,
  onDarkModeToggle,
  notificationCount = 0,
  onNotificationsClick,
  onProfileClick,
  onSettingsClick,
  onLogout,
  // Sidebar
  logo,
  logoCollapsed,
  sidebarFooter,
  // Tool Launcher
  tools = [],
  onToolSelect,
  recentToolIds = [],
  // Layout options
  sidebarDefaultCollapsed = false,
  hideSidebarOnMobile = true,
  topBarLeftContent,
  topBarRightContent
}) {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    sidebarDefaultCollapsed || isMobile
  );
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [toolLauncherOpen, setToolLauncherOpen] = useState(false);
  const handleSidebarCollapse = useCallback((collapsed) => {
    setSidebarCollapsed(collapsed);
  }, []);
  const handleMobileMenuClick = useCallback(() => {
    setMobileSidebarOpen((prev) => !prev);
  }, []);
  useToolLauncherShortcut(() => setToolLauncherOpen(true));
  const sidebarWidth = sidebarCollapsed ? layout.sidebarCollapsedWidth : layout.sidebarWidth;
  const showSidebar = !isMobile || !hideSidebarOnMobile || mobileSidebarOpen;
  return /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", minHeight: "100vh" }, children: [
    /* @__PURE__ */ jsx(
      TopBar,
      {
        title,
        user,
        showMenuButton: isMobile && hideSidebarOnMobile,
        onMenuClick: handleMobileMenuClick,
        darkMode,
        onDarkModeToggle,
        notificationCount,
        onNotificationsClick,
        onProfileClick,
        onSettingsClick,
        onLogout,
        leftContent: topBarLeftContent,
        rightContent: topBarRightContent
      }
    ),
    showSidebar && /* @__PURE__ */ jsx(
      Sidebar,
      {
        items: navItems,
        activeItemId: activeNavItemId,
        collapsed: sidebarCollapsed && !isMobile,
        onCollapsedChange: !isMobile ? handleSidebarCollapse : void 0,
        logo,
        logoCollapsed,
        footer: sidebarFooter,
        onItemClick: onNavItemClick
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        component: "main",
        sx: {
          flexGrow: 1,
          pt: `${layout.topBarHeight}px`,
          pl: showSidebar && !isMobile ? `${sidebarWidth}px` : 0,
          transition: muiTheme.transitions.create(["padding-left"], {
            easing: muiTheme.transitions.easing.sharp,
            duration: muiTheme.transitions.duration.enteringScreen
          }),
          minHeight: "100vh",
          backgroundColor: "background.default"
        },
        children: /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              p: { xs: 2, sm: 3 },
              maxWidth: layout.maxContentWidth,
              mx: "auto"
            },
            children
          }
        )
      }
    ),
    tools.length > 0 && /* @__PURE__ */ jsx(
      ToolLauncher,
      {
        open: toolLauncherOpen,
        onClose: () => setToolLauncherOpen(false),
        tools,
        onToolSelect,
        recentToolIds
      }
    )
  ] });
}
function LoadingButton({
  loading = false,
  loadingPosition = "center",
  loadingIndicator,
  disabled,
  children,
  startIcon,
  endIcon,
  ...props
}) {
  const indicator = loadingIndicator || /* @__PURE__ */ jsx(CircularProgress, { color: "inherit", size: 20 });
  const renderContent = () => {
    if (!loading) return children;
    switch (loadingPosition) {
      case "start":
        return children;
      case "end":
        return children;
      case "center":
      default:
        return indicator;
    }
  };
  return /* @__PURE__ */ jsx(
    Button,
    {
      ...props,
      disabled: disabled || loading,
      startIcon: loading && loadingPosition === "start" ? indicator : startIcon,
      endIcon: loading && loadingPosition === "end" ? indicator : endIcon,
      children: renderContent()
    }
  );
}
function IconButtonWithTooltip({
  tooltip,
  tooltipPlacement = "bottom",
  children,
  disabled,
  ...props
}) {
  const button = /* @__PURE__ */ jsx(IconButton, { ...props, disabled, children });
  if (disabled) {
    return /* @__PURE__ */ jsx(Tooltip, { title: tooltip, placement: tooltipPlacement, children: /* @__PURE__ */ jsx("span", { children: button }) });
  }
  return /* @__PURE__ */ jsx(Tooltip, { title: tooltip, placement: tooltipPlacement, children: button });
}
function FormField({
  name,
  control,
  transform,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      render: ({ field, fieldState }) => /* @__PURE__ */ jsx(
        TextField,
        {
          ...props,
          ...field,
          value: transform?.input ? transform.input(field.value) : field.value ?? "",
          onChange: (e) => {
            const value = transform?.output ? transform.output(e.target.value) : e.target.value;
            field.onChange(value);
          },
          error: !!fieldState.error,
          helperText: fieldState.error?.message || props.helperText
        }
      )
    }
  );
}
function FormSelect({
  name,
  control,
  options,
  label,
  helperText,
  fullWidth = true,
  size = "small",
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      render: ({ field, fieldState }) => /* @__PURE__ */ jsxs(
        FormControl,
        {
          fullWidth,
          size,
          error: !!fieldState.error,
          children: [
            label && /* @__PURE__ */ jsx(InputLabel, { children: label }),
            /* @__PURE__ */ jsx(Select, { ...props, ...field, label, value: field.value ?? "", children: options.map((option) => /* @__PURE__ */ jsx(
              MenuItem,
              {
                value: option.value,
                disabled: option.disabled,
                children: option.label
              },
              option.value
            )) }),
            (fieldState.error?.message || helperText) && /* @__PURE__ */ jsx(FormHelperText, { children: fieldState.error?.message || helperText })
          ]
        }
      )
    }
  );
}
function FormCheckbox({
  name,
  control,
  label,
  helperText,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      render: ({ field, fieldState }) => /* @__PURE__ */ jsxs(FormControl, { error: !!fieldState.error, children: [
        /* @__PURE__ */ jsx(
          FormControlLabel,
          {
            control: /* @__PURE__ */ jsx(
              Checkbox,
              {
                ...props,
                checked: !!field.value,
                onChange: (e) => field.onChange(e.target.checked)
              }
            ),
            label
          }
        ),
        (fieldState.error?.message || helperText) && /* @__PURE__ */ jsx(FormHelperText, { children: fieldState.error?.message || helperText })
      ] })
    }
  );
}
function SearchInput({
  value: controlledValue,
  onChange,
  onSearch,
  debounceMs = 300,
  showClearButton = true,
  placeholder = "Search...",
  size = "small",
  ...props
}) {
  const [internalValue, setInternalValue] = useState(controlledValue ?? "");
  const isControlled = controlledValue !== void 0;
  const value = isControlled ? controlledValue : internalValue;
  useEffect(() => {
    if (isControlled) {
      setInternalValue(controlledValue);
    }
  }, [controlledValue, isControlled]);
  useEffect(() => {
    if (debounceMs === 0) return;
    const timer = setTimeout(() => {
      onSearch?.(value);
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [value, debounceMs, onSearch]);
  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value;
      if (!isControlled) {
        setInternalValue(newValue);
      }
      onChange?.(newValue);
      if (debounceMs === 0) {
        onSearch?.(newValue);
      }
    },
    [isControlled, onChange, onSearch, debounceMs]
  );
  const handleClear = useCallback(() => {
    if (!isControlled) {
      setInternalValue("");
    }
    onChange?.("");
    onSearch?.("");
  }, [isControlled, onChange, onSearch]);
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        onSearch?.(value);
      }
      if (e.key === "Escape") {
        handleClear();
      }
    },
    [value, onSearch, handleClear]
  );
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ...props,
      value,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      placeholder,
      size,
      InputProps: {
        startAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(Search, { color: "action" }) }),
        endAdornment: showClearButton && value ? /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: handleClear, edge: "end", children: /* @__PURE__ */ jsx(Clear, { fontSize: "small" }) }) }) : null,
        ...props.InputProps
      }
    }
  );
}
function DataTable({
  columns,
  data,
  loading = false,
  // Selection
  selectable = false,
  selectedIds = [],
  onSelectionChange,
  // Sorting
  sortBy,
  sortDirection = "asc",
  onSortChange,
  // Pagination
  pagination = false,
  page = 0,
  pageSize = 10,
  totalCount,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50, 100],
  // Row actions
  onRowClick,
  // Empty state
  emptyMessage = "No data available",
  emptyContent,
  // Styling
  stickyHeader = false,
  maxHeight,
  dense = false
}) {
  const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);
  const allSelected = data.length > 0 && data.every((row) => selectedSet.has(row.id));
  const someSelected = data.some((row) => selectedSet.has(row.id)) && !allSelected;
  const handleSelectAll = () => {
    if (allSelected) {
      onSelectionChange?.([]);
    } else {
      onSelectionChange?.(data.map((row) => row.id));
    }
  };
  const handleSelectRow = (id) => {
    if (selectedSet.has(id)) {
      onSelectionChange?.(selectedIds.filter((i) => i !== id));
    } else {
      onSelectionChange?.([...selectedIds, id]);
    }
  };
  const handleSort = (columnId) => {
    const newDirection = sortBy === columnId && sortDirection === "asc" ? "desc" : "asc";
    onSortChange?.(columnId, newDirection);
  };
  const getValue = (row, column) => {
    if (typeof column.accessor === "function") {
      return column.accessor(row);
    }
    return row[column.accessor];
  };
  const renderCellContent = (row, column) => {
    const value = getValue(row, column);
    if (column.render) {
      return column.render(value, row);
    }
    return value;
  };
  const isEmpty = data.length === 0 && !loading;
  return /* @__PURE__ */ jsxs(Paper, { sx: { width: "100%", overflow: "hidden" }, children: [
    loading && /* @__PURE__ */ jsx(LinearProgress, {}),
    /* @__PURE__ */ jsx(TableContainer, { sx: { maxHeight }, children: /* @__PURE__ */ jsxs(
      Table,
      {
        stickyHeader,
        size: dense ? "small" : "medium",
        children: [
          /* @__PURE__ */ jsx(TableHead, { children: /* @__PURE__ */ jsxs(TableRow, { children: [
            selectable && /* @__PURE__ */ jsx(TableCell, { padding: "checkbox", children: /* @__PURE__ */ jsx(
              Checkbox,
              {
                indeterminate: someSelected,
                checked: allSelected,
                onChange: handleSelectAll
              }
            ) }),
            columns.map((column) => /* @__PURE__ */ jsx(
              TableCell,
              {
                align: column.align || "left",
                style: { width: column.width },
                sortDirection: sortBy === column.id ? sortDirection : false,
                children: column.sortable !== false && onSortChange ? /* @__PURE__ */ jsx(
                  TableSortLabel,
                  {
                    active: sortBy === column.id,
                    direction: sortBy === column.id ? sortDirection : "asc",
                    onClick: () => handleSort(column.id),
                    children: column.label
                  }
                ) : column.label
              },
              column.id
            ))
          ] }) }),
          /* @__PURE__ */ jsx(TableBody, { children: isEmpty ? /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsx(
            TableCell,
            {
              colSpan: columns.length + (selectable ? 1 : 0),
              align: "center",
              children: emptyContent || /* @__PURE__ */ jsx(Box, { sx: { py: 4 }, children: /* @__PURE__ */ jsx(Typography, { color: "text.secondary", children: emptyMessage }) })
            }
          ) }) : data.map((row) => {
            const isSelected = selectedSet.has(row.id);
            return /* @__PURE__ */ jsxs(
              TableRow,
              {
                hover: true,
                selected: isSelected,
                onClick: () => onRowClick?.(row),
                sx: {
                  cursor: onRowClick ? "pointer" : "default"
                },
                children: [
                  selectable && /* @__PURE__ */ jsx(TableCell, { padding: "checkbox", children: /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      checked: isSelected,
                      onClick: (e) => e.stopPropagation(),
                      onChange: () => handleSelectRow(row.id)
                    }
                  ) }),
                  columns.map((column) => /* @__PURE__ */ jsx(TableCell, { align: column.align || "left", children: renderCellContent(row, column) }, column.id))
                ]
              },
              row.id
            );
          }) })
        ]
      }
    ) }),
    pagination && /* @__PURE__ */ jsx(
      TablePagination,
      {
        component: "div",
        count: totalCount ?? data.length,
        page,
        onPageChange: (_, newPage) => onPageChange?.(newPage),
        rowsPerPage: pageSize,
        onRowsPerPageChange: (e) => onPageSizeChange?.(parseInt(e.target.value, 10)),
        rowsPerPageOptions: pageSizeOptions
      }
    )
  ] });
}
function StatCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  loading = false,
  onClick,
  sx
}) {
  const getTrendColor = () => {
    if (!trend) return "text.secondary";
    if (trend.direction === "up") return "success.main";
    if (trend.direction === "down") return "error.main";
    return "text.secondary";
  };
  const getTrendIcon = () => {
    if (!trend) return null;
    const iconSx = { fontSize: 16, mr: 0.5 };
    if (trend.direction === "up") return /* @__PURE__ */ jsx(TrendingUp, { sx: iconSx });
    if (trend.direction === "down") return /* @__PURE__ */ jsx(TrendingDown, { sx: iconSx });
    return /* @__PURE__ */ jsx(TrendingFlat, { sx: iconSx });
  };
  return /* @__PURE__ */ jsx(
    Card,
    {
      sx: {
        cursor: onClick ? "pointer" : "default",
        transition: "box-shadow 0.2s",
        "&:hover": onClick ? {
          boxShadow: 4
        } : {},
        ...sx
      },
      onClick,
      children: /* @__PURE__ */ jsxs(CardContent, { children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 2
            },
            children: [
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body2",
                  color: "text.secondary",
                  fontWeight: 500,
                  children: title
                }
              ),
              icon && /* @__PURE__ */ jsx(
                Box,
                {
                  sx: {
                    color: "primary.main",
                    display: "flex",
                    alignItems: "center"
                  },
                  children: icon
                }
              )
            ]
          }
        ),
        loading ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "60%", height: 40 }),
          /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "40%", height: 20 })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "h4", fontWeight: 600, gutterBottom: true, children: value }),
          /* @__PURE__ */ jsxs(
            Box,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              },
              children: [
                subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: subtitle }),
                trend && /* @__PURE__ */ jsxs(
                  Box,
                  {
                    sx: {
                      display: "flex",
                      alignItems: "center",
                      color: getTrendColor()
                    },
                    children: [
                      getTrendIcon(),
                      /* @__PURE__ */ jsxs(Typography, { variant: "body2", fontWeight: 500, children: [
                        trend.value > 0 ? "+" : "",
                        trend.value,
                        "%",
                        trend.label && /* @__PURE__ */ jsx(
                          Typography,
                          {
                            component: "span",
                            variant: "body2",
                            color: "text.secondary",
                            sx: { ml: 0.5 },
                            children: trend.label
                          }
                        )
                      ] })
                    ]
                  }
                )
              ]
            }
          )
        ] })
      ] })
    }
  );
}
function InfoList({
  items,
  loading = false,
  dividers = true,
  dense = false
}) {
  if (loading) {
    return /* @__PURE__ */ jsx(List, { dense, children: [1, 2, 3].map((i) => /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsx(
      ListItemText,
      {
        primary: /* @__PURE__ */ jsx(Skeleton, { width: "30%" }),
        secondary: /* @__PURE__ */ jsx(Skeleton, { width: "60%" })
      }
    ) }, i)) });
  }
  return /* @__PURE__ */ jsx(List, { dense, disablePadding: true, children: items.map((item, index) => /* @__PURE__ */ jsxs(React2.Fragment, { children: [
    /* @__PURE__ */ jsxs(
      ListItem,
      {
        secondaryAction: item.action,
        sx: { py: dense ? 1 : 1.5 },
        children: [
          item.icon && /* @__PURE__ */ jsx(ListItemIcon, { sx: { minWidth: 40 }, children: item.icon }),
          /* @__PURE__ */ jsx(
            ListItemText,
            {
              primary: /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body2",
                  color: "text.secondary",
                  sx: { mb: 0.5 },
                  children: item.label
                }
              ),
              secondary: /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "text.primary", children: item.value }),
              disableTypography: true
            }
          )
        ]
      }
    ),
    dividers && index < items.length - 1 && /* @__PURE__ */ jsx(Divider, { component: "li" })
  ] }, item.label)) });
}
function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  loading = false,
  maxWidth = "xs"
}) {
  const handleConfirm = async () => {
    await onConfirm();
  };
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      open,
      onClose: loading ? void 0 : onClose,
      maxWidth,
      fullWidth: true,
      children: [
        /* @__PURE__ */ jsx(DialogTitle, { children: title }),
        /* @__PURE__ */ jsx(DialogContent, { children: typeof message === "string" ? /* @__PURE__ */ jsx(DialogContentText, { children: message }) : message }),
        /* @__PURE__ */ jsxs(DialogActions, { children: [
          /* @__PURE__ */ jsx(Button, { onClick: onClose, disabled: loading, children: cancelText }),
          /* @__PURE__ */ jsx(
            LoadingButton,
            {
              onClick: handleConfirm,
              color: confirmColor,
              variant: "contained",
              loading,
              autoFocus: true,
              children: confirmText
            }
          )
        ] })
      ]
    }
  );
}
var statusConfig = {
  success: { color: "success", label: "Success" },
  warning: { color: "warning", label: "Warning" },
  error: { color: "error", label: "Error" },
  info: { color: "info", label: "Info" },
  default: { color: "default", label: "Default" },
  pending: { color: "warning", label: "Pending" },
  active: { color: "success", label: "Active" },
  inactive: { color: "default", label: "Inactive" },
  completed: { color: "success", label: "Completed" },
  draft: { color: "default", label: "Draft" }
};
function StatusChip({
  status,
  customLabel,
  size = "small",
  ...props
}) {
  const config = statusConfig[status] || statusConfig.default;
  return /* @__PURE__ */ jsx(
    Chip,
    {
      ...props,
      label: customLabel || config.label,
      color: config.color,
      size
    }
  );
}
function EmptyState({
  icon,
  title,
  description,
  action,
  children
}) {
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 4,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              color: "text.secondary",
              mb: 2,
              "& > svg": {
                fontSize: 64
              }
            },
            children: icon || /* @__PURE__ */ jsx(Inbox, {})
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "h6", gutterBottom: true, children: title }),
        description && /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "body2",
            color: "text.secondary",
            sx: { maxWidth: 400, mb: action ? 3 : 0 },
            children: description
          }
        ),
        action && /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: action.onClick, children: action.label }),
        children
      ]
    }
  );
}
function PageLoader({
  message,
  fullScreen = false,
  transparent = false
}) {
  return /* @__PURE__ */ jsx(Fade, { in: true, children: /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: fullScreen ? "100vh" : 400,
        backgroundColor: transparent ? "transparent" : "background.default",
        position: fullScreen ? "fixed" : "relative",
        inset: fullScreen ? 0 : "auto",
        zIndex: fullScreen ? 9999 : "auto"
      },
      children: [
        /* @__PURE__ */ jsx(CircularProgress, { size: 48 }),
        message && /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "body2",
            color: "text.secondary",
            sx: { mt: 2 },
            children: message
          }
        )
      ]
    }
  ) });
}
function SkeletonList({
  count = 5,
  avatar = false,
  secondaryText = true,
  dense = false
}) {
  return /* @__PURE__ */ jsx(List, { dense, children: Array.from({ length: count }).map((_, index) => /* @__PURE__ */ jsxs(ListItem, { children: [
    avatar && /* @__PURE__ */ jsx(ListItemAvatar, { children: /* @__PURE__ */ jsx(Skeleton, { variant: "circular", width: 40, height: 40 }) }),
    /* @__PURE__ */ jsx(
      ListItemText,
      {
        primary: /* @__PURE__ */ jsx(Skeleton, { width: "60%" }),
        secondary: secondaryText ? /* @__PURE__ */ jsx(Skeleton, { width: "40%" }) : void 0
      }
    )
  ] }, index)) });
}
function SkeletonCard({
  header = true,
  avatar = false,
  lines = 3,
  actions = false
}) {
  return /* @__PURE__ */ jsxs(Card, { children: [
    header && /* @__PURE__ */ jsx(
      CardHeader,
      {
        avatar: avatar ? /* @__PURE__ */ jsx(Skeleton, { variant: "circular", width: 40, height: 40 }) : void 0,
        title: /* @__PURE__ */ jsx(Skeleton, { width: "60%" }),
        subheader: /* @__PURE__ */ jsx(Skeleton, { width: "40%" })
      }
    ),
    /* @__PURE__ */ jsxs(CardContent, { children: [
      Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsx(
        Skeleton,
        {
          width: index === lines - 1 ? "60%" : "100%",
          sx: { mb: 1 }
        },
        index
      )),
      actions && /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", gap: 1, mt: 2 }, children: [
        /* @__PURE__ */ jsx(Skeleton, { variant: "rounded", width: 80, height: 36 }),
        /* @__PURE__ */ jsx(Skeleton, { variant: "rounded", width: 80, height: 36 })
      ] })
    ] })
  ] });
}
function Breadcrumbs({
  items,
  separator = /* @__PURE__ */ jsx(NavigateNext, { fontSize: "small" }),
  maxItems
}) {
  return /* @__PURE__ */ jsx(
    Breadcrumbs$1,
    {
      separator,
      maxItems,
      "aria-label": "breadcrumb",
      children: items.map((item, index) => {
        const isLast = index === items.length - 1;
        const content = /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 0.5 }, children: [
          item.icon,
          item.label
        ] });
        if (isLast) {
          return /* @__PURE__ */ jsx(
            Typography,
            {
              color: "text.primary",
              sx: { display: "flex", alignItems: "center" },
              children: content
            },
            item.label
          );
        }
        return /* @__PURE__ */ jsx(
          Link,
          {
            href: item.href,
            onClick: (e) => {
              if (item.onClick) {
                e.preventDefault();
                item.onClick();
              }
            },
            underline: "hover",
            color: "inherit",
            sx: { display: "flex", alignItems: "center", cursor: "pointer" },
            children: content
          },
          item.label
        );
      })
    }
  );
}
function Tabs({ tabs, value, onChange, ...props }) {
  const handleChange = (_, newValue) => {
    onChange(newValue);
  };
  return /* @__PURE__ */ jsx(Tabs$1, { value, onChange: handleChange, ...props, children: tabs.map((tab) => /* @__PURE__ */ jsx(
    Tab,
    {
      value: tab.id,
      label: /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
        tab.icon,
        tab.label,
        tab.badge !== void 0 && tab.badge > 0 && /* @__PURE__ */ jsx(
          Box,
          {
            component: "span",
            sx: {
              backgroundColor: "primary.main",
              color: "primary.contrastText",
              borderRadius: "10px",
              px: 0.75,
              py: 0.25,
              fontSize: "0.75rem",
              fontWeight: 600,
              minWidth: 20,
              textAlign: "center"
            },
            children: tab.badge > 99 ? "99+" : tab.badge
          }
        )
      ] }),
      disabled: tab.disabled
    },
    tab.id
  )) });
}
function TabPanel({
  children,
  value,
  activeValue,
  keepMounted = false
}) {
  const isActive = value === activeValue;
  if (!keepMounted && !isActive) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      role: "tabpanel",
      hidden: !isActive,
      id: `tabpanel-${value}`,
      "aria-labelledby": `tab-${value}`,
      children: isActive && children
    }
  );
}
var defaultColors = Object.values(colors.chart);
function RadarChart({
  data,
  series,
  title,
  height = 400,
  showLegend = true,
  showTooltip = true,
  angleAxisDataKey = "category",
  domain = [0, 100]
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(Box, { children: [
    title && /* @__PURE__ */ jsx(Typography, { variant: "h6", gutterBottom: true, children: title }),
    /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height, children: /* @__PURE__ */ jsxs(RadarChart$1, { data, children: [
      /* @__PURE__ */ jsx(PolarGrid, { stroke: theme.palette.divider }),
      /* @__PURE__ */ jsx(
        PolarAngleAxis,
        {
          dataKey: angleAxisDataKey,
          tick: { fill: theme.palette.text.secondary, fontSize: 12 }
        }
      ),
      /* @__PURE__ */ jsx(
        PolarRadiusAxis,
        {
          domain,
          tick: { fill: theme.palette.text.secondary, fontSize: 10 }
        }
      ),
      series.map((s, index) => /* @__PURE__ */ jsx(
        Radar,
        {
          name: s.name,
          dataKey: s.dataKey,
          stroke: s.color || defaultColors[index % defaultColors.length],
          fill: s.color || defaultColors[index % defaultColors.length],
          fillOpacity: s.fillOpacity ?? 0.3
        },
        s.dataKey
      )),
      showTooltip && /* @__PURE__ */ jsx(
        Tooltip$1,
        {
          contentStyle: {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 8
          }
        }
      ),
      showLegend && /* @__PURE__ */ jsx(Legend, {})
    ] }) })
  ] });
}
function GaugeChart({
  value,
  min = 0,
  max = 100,
  title,
  label,
  size = 200,
  thickness = 20,
  colors: customColors,
  thresholds = { low: 33, high: 66 }
}) {
  const theme = useTheme();
  const defaultColors5 = {
    low: theme.palette.error.main,
    medium: theme.palette.warning.main,
    high: theme.palette.success.main,
    background: theme.palette.grey[200]
  };
  const gaugeColors = { ...defaultColors5, ...customColors };
  const normalizedValue = Math.min(
    100,
    Math.max(0, (value - min) / (max - min) * 100)
  );
  const getValueColor = () => {
    if (normalizedValue < thresholds.low) return gaugeColors.low;
    if (normalizedValue < thresholds.high) return gaugeColors.medium;
    return gaugeColors.high;
  };
  const gaugeData = [
    { value: normalizedValue, color: getValueColor() },
    { value: 100 - normalizedValue, color: gaugeColors.background }
  ];
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative"
      },
      children: [
        title && /* @__PURE__ */ jsx(Typography, { variant: "subtitle2", color: "text.secondary", gutterBottom: true, children: title }),
        /* @__PURE__ */ jsxs(Box, { sx: { position: "relative", width: size, height: size / 2 + 20 }, children: [
          /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height: size, children: /* @__PURE__ */ jsx(PieChart, { children: /* @__PURE__ */ jsx(
            Pie,
            {
              data: gaugeData,
              cx: "50%",
              cy: "100%",
              startAngle: 180,
              endAngle: 0,
              innerRadius: size / 2 - thickness,
              outerRadius: size / 2,
              dataKey: "value",
              stroke: "none",
              children: gaugeData.map((entry, index) => /* @__PURE__ */ jsx(Cell, { fill: entry.color }, `cell-${index}`))
            }
          ) }) }),
          /* @__PURE__ */ jsxs(
            Box,
            {
              sx: {
                position: "absolute",
                bottom: 10,
                left: "50%",
                transform: "translateX(-50%)",
                textAlign: "center"
              },
              children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h4", fontWeight: 600, children: Math.round(value) }),
                label && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "text.secondary", children: label })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var defaultColors2 = Object.values(colors.chart);
function BarChart({
  data,
  series,
  title,
  height = 300,
  horizontal = false,
  stacked = false,
  showGrid = true,
  showLegend = true,
  showTooltip = true,
  xAxisLabel,
  yAxisLabel,
  barSize,
  colorByValue
}) {
  const theme = useTheme();
  const Layout = horizontal ? "vertical" : "horizontal";
  return /* @__PURE__ */ jsxs(Box, { children: [
    title && /* @__PURE__ */ jsx(Typography, { variant: "h6", gutterBottom: true, children: title }),
    /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height, children: /* @__PURE__ */ jsxs(
      BarChart$1,
      {
        data,
        layout: Layout,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          showGrid && /* @__PURE__ */ jsx(
            CartesianGrid,
            {
              strokeDasharray: "3 3",
              stroke: theme.palette.divider
            }
          ),
          horizontal ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              XAxis,
              {
                type: "number",
                tick: { fill: theme.palette.text.secondary },
                label: xAxisLabel ? { value: xAxisLabel, position: "bottom", fill: theme.palette.text.secondary } : void 0
              }
            ),
            /* @__PURE__ */ jsx(
              YAxis,
              {
                type: "category",
                dataKey: "name",
                tick: { fill: theme.palette.text.secondary },
                label: yAxisLabel ? { value: yAxisLabel, angle: -90, position: "left", fill: theme.palette.text.secondary } : void 0
              }
            )
          ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              XAxis,
              {
                dataKey: "name",
                tick: { fill: theme.palette.text.secondary },
                label: xAxisLabel ? { value: xAxisLabel, position: "bottom", fill: theme.palette.text.secondary } : void 0
              }
            ),
            /* @__PURE__ */ jsx(
              YAxis,
              {
                tick: { fill: theme.palette.text.secondary },
                label: yAxisLabel ? { value: yAxisLabel, angle: -90, position: "left", fill: theme.palette.text.secondary } : void 0
              }
            )
          ] }),
          showTooltip && /* @__PURE__ */ jsx(
            Tooltip$1,
            {
              contentStyle: {
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 8
              }
            }
          ),
          showLegend && /* @__PURE__ */ jsx(Legend, {}),
          series.map((s, index) => /* @__PURE__ */ jsx(
            Bar,
            {
              dataKey: s.dataKey,
              name: s.name,
              fill: s.color || defaultColors2[index % defaultColors2.length],
              stackId: stacked ? "stack" : s.stackId,
              barSize,
              children: colorByValue && data.map((entry, i) => /* @__PURE__ */ jsx(
                Cell,
                {
                  fill: colorByValue(entry[s.dataKey])
                },
                `cell-${i}`
              ))
            },
            s.dataKey
          ))
        ]
      }
    ) })
  ] });
}
var defaultColors3 = Object.values(colors.chart);
function LineChart({
  data,
  series,
  title,
  height = 300,
  showGrid = true,
  showLegend = true,
  showTooltip = true,
  xAxisLabel,
  yAxisLabel,
  showArea = false
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(Box, { children: [
    title && /* @__PURE__ */ jsx(Typography, { variant: "h6", gutterBottom: true, children: title }),
    /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height, children: /* @__PURE__ */ jsxs(
      LineChart$1,
      {
        data,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          showGrid && /* @__PURE__ */ jsx(
            CartesianGrid,
            {
              strokeDasharray: "3 3",
              stroke: theme.palette.divider
            }
          ),
          /* @__PURE__ */ jsx(
            XAxis,
            {
              dataKey: "name",
              tick: { fill: theme.palette.text.secondary },
              label: xAxisLabel ? { value: xAxisLabel, position: "bottom", fill: theme.palette.text.secondary } : void 0
            }
          ),
          /* @__PURE__ */ jsx(
            YAxis,
            {
              tick: { fill: theme.palette.text.secondary },
              label: yAxisLabel ? { value: yAxisLabel, angle: -90, position: "left", fill: theme.palette.text.secondary } : void 0
            }
          ),
          showTooltip && /* @__PURE__ */ jsx(
            Tooltip$1,
            {
              contentStyle: {
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 8
              }
            }
          ),
          showLegend && /* @__PURE__ */ jsx(Legend, {}),
          series.map((s, index) => {
            const color = s.color || defaultColors3[index % defaultColors3.length];
            return /* @__PURE__ */ jsx(
              Line,
              {
                type: s.type || "monotone",
                dataKey: s.dataKey,
                name: s.name,
                stroke: color,
                strokeWidth: s.strokeWidth || 2,
                dot: s.dot !== false,
                fill: showArea ? color : void 0,
                fillOpacity: showArea ? 0.1 : void 0
              },
              s.dataKey
            );
          })
        ]
      }
    ) })
  ] });
}
var defaultColors4 = Object.values(colors.chart);
function PieChart2({
  data,
  title,
  height = 300,
  showLegend = true,
  showTooltip = true,
  showLabels = false,
  innerRadius = 0,
  outerRadius = 80,
  paddingAngle = 2
}) {
  const theme = useTheme();
  const renderCustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius: innerRadius2,
    outerRadius: outerRadius2,
    percent,
    name
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius2 + (outerRadius2 - innerRadius2) * 1.4;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y,
        fill: theme.palette.text.primary,
        textAnchor: x > cx ? "start" : "end",
        dominantBaseline: "central",
        fontSize: 12,
        children: `${name}: ${(percent * 100).toFixed(0)}%`
      }
    );
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    title && /* @__PURE__ */ jsx(Typography, { variant: "h6", gutterBottom: true, textAlign: "center", children: title }),
    /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height, children: /* @__PURE__ */ jsxs(PieChart, { children: [
      /* @__PURE__ */ jsx(
        Pie,
        {
          data,
          cx: "50%",
          cy: "50%",
          innerRadius,
          outerRadius,
          paddingAngle,
          dataKey: "value",
          label: showLabels ? renderCustomLabel : void 0,
          labelLine: showLabels,
          children: data.map((entry, index) => /* @__PURE__ */ jsx(
            Cell,
            {
              fill: entry.color || defaultColors4[index % defaultColors4.length]
            },
            `cell-${index}`
          ))
        }
      ),
      showTooltip && /* @__PURE__ */ jsx(
        Tooltip$1,
        {
          contentStyle: {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 8
          }
        }
      ),
      showLegend && /* @__PURE__ */ jsx(Legend, {})
    ] }) })
  ] });
}

export { AppShell, BarChart, Breadcrumbs, ConfirmDialog, DataTable, EmptyState, FormCheckbox, FormField, FormSelect, GaugeChart, IconButtonWithTooltip, InfoList, LineChart, LoadingButton, PageLoader, PieChart2 as PieChart, RadarChart, SearchInput, Sidebar, SkeletonCard, SkeletonList, StatCard, StatusChip, TabPanel, Tabs, ThemeProvider, ToolLauncher, TopBar, borderRadius, breakpoints, colors, layout, shadows, spacing, transitions, typography, useTheme2 as useTheme, useToolLauncherShortcut, zIndex };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map